import script from "./SupportRequestFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportRequestFormView.vue?vue&type=script&setup=true&lang=js"

import "./SupportRequestFormView.vue?vue&type=style&index=0&id=2af57e4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2af57e4c"]])

export default __exports__